<div class="about-page">
  <!-- Page Header -->
  <section class="page-header">
    <div class="container">
      <h1 class="page-title">Über uns</h1>
      <p class="page-subtitle">Lernen Sie Mitra Sanitär GmbH kennen</p>
    </div>
  </section>

  <!-- Navigation Cards -->
  <section class="about-navigation section">
    <div class="container">
      <div class="row g-4">
        <div class="col-lg-6">
          <a routerLink="/about/company" class="about-nav-card">
            <div class="nav-icon">
              <i class="fas fa-building"></i>
            </div>
            <div class="nav-content">
              <h3>Unser Unternehmen</h3>
              <p>Erfahren Sie mehr über unsere Geschichte, Vision und Werte</p>
              <i class="fas fa-arrow-right nav-arrow"></i>
            </div>
          </a>
        </div>
        <div class="col-lg-6">
          <a routerLink="/about/team" class="about-nav-card">
            <div class="nav-icon">
              <i class="fas fa-users"></i>
            </div>
            <div class="nav-content">
              <h3>Unser Team</h3>
              <p>Lernen Sie die Experten hinter unseren erfolgreichen Projekten kennen</p>
              <i class="fas fa-arrow-right nav-arrow"></i>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</div>